module.exports = __webpack_public_path__ + "assets/img/iab_logo.webp?d26f0d15fa259d6b38fe2d2ed2a3f863";